var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordingsTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1105_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8391 11.4062C39.6397 11.2994 39.4151 11.2486 39.1892 11.2594C38.9633 11.2701 38.7446 11.3419 38.5563 11.4672L33 15.1641V11.25C33 10.587 32.7366 9.95107 32.2678 9.48223C31.7989 9.01339 31.163 8.75 30.5 8.75H5.5C4.83696 8.75 4.20107 9.01339 3.73223 9.48223C3.26339 9.95107 3 10.587 3 11.25V28.75C3 29.413 3.26339 30.0489 3.73223 30.5178C4.20107 30.9866 4.83696 31.25 5.5 31.25H30.5C31.163 31.25 31.7989 30.9866 32.2678 30.5178C32.7366 30.0489 33 29.413 33 28.75V24.8438L38.5563 28.5484C38.7626 28.6824 39.004 28.7526 39.25 28.75C39.5815 28.75 39.8995 28.6183 40.1339 28.3839C40.3683 28.1495 40.5 27.8315 40.5 27.5V12.5C40.4984 12.2751 40.4362 12.0548 40.3199 11.8623C40.2035 11.6698 40.0374 11.5122 39.8391 11.4062ZM30.5 28.75H5.5V11.25H30.5V28.75ZM38 25.1641L33 21.8313V18.1687L38 14.8438V25.1641Z",
    fill: "#0080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1105_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingsTool);
export default __webpack_public_path__ + "static/media/RecordingsTool.81ce6555a343505aa89e772ac7dd50a9.svg";
export { ForwardRef as ReactComponent };